import { defa, T }        from 'defa-object';
import { silverMapStyle } from 'scripts/defa/control/map/google-maps-silver-style';
import ControlModule      from 'scripts/poppet/control-module';
import template           from 'templates/controlMap.jst.html';
import mapInfoboxTemplate from './map/mapInfoBox.jst.html';

/* global google */ // Loaded dynamically

/**
 * defa.views.ControlMapView
 * !TODO: This view contains several hacks, when going proper, fix ALL the hacks - make it a control-module, and update
 * to the 1.3.* - style of view! A simple view for viewing a gps-position.
 * @version 1.2.1
 */


const selectors = {
	container    : '[data-container=map-container]',
	buttonDevices: '[data-click=map-devices]',
	buttonRefresh: '[data-click=map-refresh]',
	buttonToggle : '[data-toggle=expand-spoiler]',
};


const apiRoot = defa.vars.apiHost;
const api     = {
	latlong   : apiRoot + '/units/%s/gpslatest',
	googlemaps: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCAFiHj-OHoO-vsPeGWJAGUWdWYkxFkIMU',
};


const ControlMapView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	mapInitialized: false,
	
	template          : template,
	className         : function () {
		return this._getClassName( 'control-map' );
	},
	expandedNavState  : 'unit:control:map',
	compressedNavState: 'unit:control:overview',
	
	ui: {
		container: selectors.container,
		devices  : selectors.buttonDevices,
		refresh  : selectors.buttonRefresh,
		toggle   : selectors.buttonToggle,
	},
	
	events: {
		'click @ui.toggle' : 'onClickToggle',
		'click @ui.devices': 'onClickDevices',
		'click @ui.refresh': 'onClickRefresh',
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when the view renders.
	 * @void
	 */
	onRender: function () {
	
	},
	
	onDomRefresh: function () {
		if ( this._isOpen() ) {
			this.lazyInitMap();
		}
	},
	
	/**
	 * Triggers when the devices button is clicked.
	 * @void
	 */
	onClickDevices: function () {
		this.trigger( 'nav', 'unit:list' );
	},
	
	/**
	 * Triggers when the refresh button is clicked.
	 * @void
	 */
	onClickRefresh: function () {
		this.getLatLong();
	},
	
	onClickToggle: function ( event ) {
		ControlModule.prototype.onClickToggle.call( this, event );
		this.lazyInitMap();
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	lazyInitMap: function () {
		if ( !this.mapInitialized ) {
			installRobotoFontHack();
			
			this.busy();
			if ( !window.google ) {
				this.getMaps();
			} else {
				this.getLatLong();
			}
			this.mapInitialized = true;
		}
		
	},
	
	/**
	 * Fetches GoogleMaps
	 * @void
	 */
	getMaps: function () {
		$.getScript( api.googlemaps )
		 .done( () => {
			 this.getLatLong();
		 } );
	},
	
	/**
	 * Fetches the unit's lat and long from the server.
	 * @void
	 */
	getLatLong: function () {
		let url = api.latlong.replace( '%s', this.model.get( 'id' ) );
		
		$.get( url )
		 .done( ( response ) => {
			
			 let locationGPS = {
				 lat: response.latitude || 0,
				 lng: response.longitude || 0,
			 };
			
			 if ( 0 === locationGPS.lat && 0 === locationGPS.lng ) {
				 console.log( 'instead of 0,0 -- using mock position @ DEFA Slependen' );
				 locationGPS = { lat: 59.8777517, lng: 10.5019803 };
			 }
			
			 if ( !this.map ) {
				 this.drawMap( locationGPS );
			 }
			 console.log( response );
			 this.drawMarker( {
				 locationGPS,
				 time    : response.positionTime,
				 heading : response.heading,
				 speed   : response.speed,
				 accuracy: response.accuracy
			 } );
			 this.idle();
			
		 } )
		 .fail( ( response ) => {
			 this.map = null;
			 this.ui.container.html( '<p class="error">'+ T.tc('UnitMap', 'Could not get position.') +'</p>' );
			 console.log('error getting coordinate',response);
			 this.idle();
		 } );
		
	},
	
	/**
	 * Draws the map to the view.
	 * @void
	 */
	drawMap: function ( locationGPS ) {
		// set element height.
		if ( $( window ).outerWidth() < 700 ) {
			this.ui.container.css( 'height', 'calc(100vh - 275px)' );
		} else {
			this.ui.container.css( 'height', 'calc(100vh - 275px)' );
		}
		
		this.map = new google.maps.Map( this.ui.container.get( 0 ), {
			zoom          : 14,
			animation     : google.maps.Animation.DROP,
			center        : locationGPS,
			mapTypeControl: true,
			styles        : silverMapStyle
		} );
		
	},
	
	/**
	 * Draws the marker on the map.
	 * @void
	 */
	drawMarker: function ( { locationGPS, time, heading, ignition, speed, accuracy } ) {
		console.log( 'drawMarker', locationGPS );
		// clear marker
		if ( this.marker ) {
			this.marker.setMap( null );
		}
		if ( this.circle ) {
			this.circle.setMap( null );
		}
		
		// draw marker
		const marker = new google.maps.Marker( {
			position : locationGPS,
			animation: google.maps.Animation.DROP,
			map      : this.map,
		} );
		
		const circle = new google.maps.Circle( {
			fillColor   : '#4392ff',
			fillOpacity : 0.35,
			strokeWeight: 0,
			map         : this.map,
			center      : locationGPS,
			radius      : accuracy
		} );
		
		let alias        = this.options.unit.get( 'alias' );
		const infoWindow = new google.maps.InfoWindow( {
			content: mapInfoboxTemplate( { locationGPS, time, alias, heading, ignition, speed } )
		} );
		marker.addListener( 'click', () => {
			infoWindow.open( this.map, marker );
		} );
		
		this.marker = marker;
		this.circle = circle;
		this.map.panTo( locationGPS );
	},
	
} );


function installRobotoFontHack() {
	const isRoboto     = ( element ) => element.href && element.href.indexOf( 'css?family=Roboto' ) !== -1;
	const head         = $( 'head' )[ 0 ];
	const insertBefore = head.insertBefore;
	head.insertBefore  = ( newElement, refElement ) => {
		if ( isRoboto( newElement ) ) {
			console.log( 'suppressed Roboto' );
			return;
		}
		insertBefore.call( head, newElement, refElement );
	};
	const appendChild  = head.appendChild;
	head.appendChild   = ( element ) => {
		if ( isRoboto( element ) ) {
			console.log( 'suppressed Roboto' );
			return;
		}
		appendChild.call( head, element );
	};
}

export default ControlMapView;